import {getCookieValue, setCookie} from "./Cookies";



export function initTracking ()
{
    const searchParams = new URLSearchParams(window.location.search);
    const utmSource = searchParams.get("utm_source") ?? getCookieValue("utm_source") ?? '';
    const utmMedium = searchParams.get("utm_medium") ?? getCookieValue("utm_medium") ?? '';
    const utmCampaign = searchParams.get("utm_campaign") ?? getCookieValue("utm_campaign") ?? '';

    setCookie("utm_source", utmSource, 30);
    setCookie("utm_medium", utmMedium, 30);
    setCookie("utm_campaign", utmCampaign, 30);

    return {
        utmSource,
        utmMedium,
        utmCampaign
    }
}